import React from 'react'
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { Guardian } from '@xaamin/guardian';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const AutofacturacionListActions = (props) => {
  return (
    <>
      { Guardian.allows('autofacturacion.subir.archivo') && (
        <Button as={ Link }
          className="mr-2"
          to="/modulos/autofacturacion/archivos/upload"
        >
          Subir archivo
        </Button>
      )}

      <Button variant="link"
        as={ Link }
        className="text-secondary"
        to="/modulos/autofacturacion/tickets"
      >
        Tickets { ' ' }
        <FontAwesomeIcon icon={ ['fas', 'chevron-right'] } />
      </Button>
    </>
  )
}

export default AutofacturacionListActions;